import {AbstractReactComponent, i18n, Icon} from 'mc/lib';
import {CustomSelect} from 'mc/lib/field';
import {ModalActions} from 'mc/lib/modal';
import {objectById, storeFromArea} from 'mc/lib/utils';
import React from 'react';
import {connect} from 'react-redux';
import {toastr} from 'react-redux-toastr';
import {browserHistory} from 'react-router';
import {
    Alert,
    Button,
    Card,
    Col,
    Form,
    FormGroup,
    Input,
    Nav,
    Navbar,
    NavbarBrand,
    NavItem,
    NavLink,
    Row,
} from 'reactstrap';
import {TypZaborListActions} from '../actions';
import {
    Loading,
    LoginForm,
    PasswordRecoveryForm,
    RegisterForm,
    TypZaborDetail,
    TypZaborListItem,
    ZadostStateCheckForm,
} from '../components';
import {getOuterHeight} from '../utils';
import './LoginPage.scss';

class WelcomePage extends AbstractReactComponent {

    state : {selectedId: ?number, listHeight: ?number, initialized:boolean} = {
        selectedId: null,
        listHeight: null,
        initialized: false
    };

    componentDidMount() {
        this.dispatch(TypZaborListActions.fetchIfNeeded());
        this.setState({listHeight: this.getListHeight()});
    }

    toHome = () => {
        browserHistory.push(serverContextPath);
    };

    handleFilterTypZabor = event => {
        this.dispatch(TypZaborListActions.filter(event.target.value));
    };

    showRegisterModal = () => {
        this.dispatch(ModalActions.show(RegisterForm, {onRegister: () => {
            this.dispatch(ModalActions.hide());
            toastr.info(i18n('toastr.registerDone'));
        }}, i18n('modal.register'), {size: 'sm'}))
    };

    showPassRecoveryModal = () => {
        this.dispatch(ModalActions.show(PasswordRecoveryForm, {onComplete: () => {
            this.dispatch(ModalActions.hide());
            toastr.info(i18n('toastr.recoveryPass'));
        }}, i18n('modal.passRecovery')))
    };

    componentDidUpdate() {
        this.dispatch(TypZaborListActions.fetchIfNeeded());

        if (!this.state.initialized) {
            const {typZaborList} = this.props;

            if (typZaborList.fetched && typZaborList.filteredRows) {
                this.setState({
                    initialized: true,
                    selectedId: typZaborList.filteredRows.length > 0 ? typZaborList.filteredRows[0].id : null
                })
            }
        }
    }

    componentWillUnmount() {
        document.getElementsByTagName("body")[0].className = "";
    }

    getListHeight() {
        if (window.innerWidth < 768) {
            return null;
        }

        const header = document.getElementById('header');
        const heading = document.getElementById('heading');
        const filter = document.getElementById('filter');

        const headerHeight = getOuterHeight(header);
        const filterHeight = filter ? filter.offsetHeight : 40;
        const headingHeight = heading ? getOuterHeight(heading) : 70;

        return window.innerHeight - headerHeight - filterHeight - headingHeight - 60;
    }

    renderDetail() {
        const {selectedId} = this.state;
        if (selectedId == null) {
            return null;
        }

        const {rows} = this.props.typZaborList;
        const typZabor = objectById(rows, selectedId);
        if (typZabor == null) {
            return null;
        }

        return (
            <div>
                <TypZaborDetail typZabor={typZabor}/>
                <Button block color="success" type="button" onClick={() => browserHistory.push(serverContextPath + '/login?idTypZabor=' + typZabor.id)}>
                    <Icon icon="plus-circle"/> {i18n('loginPage.createZadost')}
                </Button>
            </div>
        );
    }

    render() {
        const {filter, filteredRows, fetching, fetched} = this.props.typZaborList;
        const {selectedId, listHeight} = this.state;

        const listStyle = {
            maxHeight: listHeight ? listHeight + 'px' : 'auto',
            overflowY:'auto'
        };

        return <Row>
            <Col xs={12}>
                <Navbar id="header" inverse fixed="top" toggleable>
                    <NavbarBrand href="javascript:void(0)">{window.APP_TITLE}</NavbarBrand>
                    <Nav className="ml-auto" navbar>
                        {window.MAP_URL && (
                            <NavItem>
                                <NavLink href={window.MAP_URL}>Přehledová mapa</NavLink>
                            </NavItem>
                        )}
                        {window.HELP_URL && (
                            <NavItem>
                                <NavLink href={window.HELP_URL} target="_blank">
                                    <Icon icon="question-circle"/>
                                </NavLink>
                            </NavItem>
                        )}
                    </Nav>
                </Navbar>
            </Col>
            <Col xs={12} lg={9}>
                <h1 id="heading">{i18n('loginPage.title')}</h1>
                <FormGroup id="filter">
                    <Input type="text"
                           onChange={this.handleFilterTypZabor}
                           value={filter.text || ""}
                           placeholder={i18n('loginPage.typZaborSearchHint')}/>
                </FormGroup>
                {fetching && <Loading block/>}
                {!fetching && fetched && filteredRows.length === 0 && (
                    <Alert color="info">{i18n('typZabor.emptyList')}</Alert>
                )}
                {!fetching && fetched && filteredRows.length > 0 && (
                    <Row>
                        <Col xs={12} md={6}>
                            <Form form="typ-zabor-form-select">
                                <Card block className="typ-zabor-select" style={listStyle}>
                                    <CustomSelect name="typZabor"
                                                  className="typ-zabor"
                                                  items={filteredRows}
                                                  renderItem={TypZaborListItem.renderListItem}
                                                  value={selectedId}
                                                  onChange={e => this.setState({selectedId: e})}
                                                  required/>
                                </Card>
                            </Form>
                        </Col>
                        <Col xs={12} md={6}>
                            {this.renderDetail()}
                        </Col>
                    </Row>
                )}
            </Col>
            <Col xs={12} lg={3} className="user-panel">
                <Card block>
                    <ZadostStateCheckForm/>
                </Card>
                <Card block>
                    <div className="form-box">
                        <LoginForm onLogin={this.toHome} onLostPassword={this.showPassRecoveryModal} />
                    </div>
                </Card>
                <Card block>
                    <h3>{i18n('registerBox.title')}</h3>
                    <p>{i18n('registerBox.info.title')}</p>
                    <ul>
                        <li>{i18n('registerBox.info.line1')}</li>
                        <li>{i18n('registerBox.info.line2')}</li>
                        <li>{i18n('registerBox.info.line3')}</li>
                    </ul>
                    <Button color="primary" block onClick={this.showRegisterModal}>{i18n('registerBox.createAcc')}</Button>
                </Card>
            </Col>
        </Row>
    }
}

const mapStateToProps = state => {
    const {app:{currentZadost: {data}}} = state;
    return {
        zadost: data,
        typZaborList: storeFromArea(state, 'typZaborList'),
    };
};

export default connect(mapStateToProps)(WelcomePage);
